module.exports = __webpack_public_path__ + "static/media/taxi.8b28fd7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/taxi.png
// module id = 1987
// module chunks = 0